import "./index.scss";

import { Box } from "@mui/material";
import { ReactComponent as UserIcon } from "assets/images/side-menu/members-on.svg";
import { ReactComponent as EditIcon } from "assets/images/square-buttons/edit-line.svg";
import { TMemberDetails } from "models/member";

export default function TrainerSection(props: { member: TMemberDetails; editCallback: any }) {
  const { member, editCallback } = props;
  return (
    <>
      <p className="title trainer-section-title">Trainer</p>
      <Box display="flex" mt={2} className="trainer-section-box">
        <UserIcon />
        <p>{member?.trainer.name}</p>
        <EditIcon className="link" onClick={editCallback} />
      </Box>
    </>
  );
}
